import { addToast } from "../../../../toasts";
import { NoFeedSection } from "../NoFeedSection";
import { ReviewSkeleton } from "../ReviewSkeleton";
import { ImportsModalCtx } from "../../ImportsModalCtx";
import { CourseraReviewItem } from "./CourseraReviewItem";
import { CourseraReviewsInfo } from "./CourseraReviewsInfo";
import { GetCourseraReviewsForm } from "./GetCourseraReviewsForm";
import { importService } from "../../../../services/importService";
import { disableButton, enableButton } from "../../../../lib/utility";
import { MultipleCheckboxService } from "../../../../services/multipleCheckboxService";
import { ReadMoreLessService } from "../../../../services/readMoreLessService";
import { switchLayoutService } from "../../../../services/switchLayoutService";

export function CourseraReviews() {
  let getFeedResp: any = {};
  let $feeds: any[] = [];
  let $feedList: null | HTMLElement = null;
  let $notFeedSection: null | HTMLElement = null;
  let $informationSection: null | HTMLElement = null;
  let $skeletonSection: null | HTMLElement = null;
  let $selectedFeedsCount: null | HTMLElement = null;
  let $feedsDisplaySection: null | HTMLElement = null;
  let $importFeedsBtns: null | NodeListOf<HTMLButtonElement> = null;
  let selectedFeedboxItems: MultipleCheckboxService;
  const readMoreLessService = new ReadMoreLessService();

  const title = "Import reviews from Coursera";
  const children = {
    GetCourseraReviewsForm: GetCourseraReviewsForm(
      { displayFeeds: (data: object) => displayFeeds(data) },
      { resetSections: resetSections },
      { showSkeleton: (enable: boolean) => showSkeleton(enable) }
    ),
    NoFeedSection: NoFeedSection({
      noFeeText: "No reviews found :(",
    }),
    CourseraReviewsInfo: CourseraReviewsInfo(),
    ReviewSkeleton: ReviewSkeleton(),
  };

  function init() {
    $feedList = document.getElementById("cs-grid-view-feed-list");
    $notFeedSection = document.getElementById("cs-no-feed-section");
    $informationSection = document.getElementById("cs-information-section");
    $skeletonSection = document.getElementById("cs-skeleton-section");
    $feedsDisplaySection = document.getElementById("cs-feed-list-section");
    $importFeedsBtns = document.querySelectorAll(
      ".cs-import-btn"
    ) as NodeListOf<HTMLButtonElement>;
    $selectedFeedsCount = document.getElementById("cs-selected-feeds-count");

    const layoutService = new switchLayoutService(
      "cs-grid-view-feed-list",
      "cs-layout-change-switch"
    );
    layoutService.loadHTML();
    layoutService.init();

    const itemIdPrefix = "cs_single_feed_";
    selectedFeedboxItems = new MultipleCheckboxService(
      enableImportBtn,
      itemIdPrefix,
      "cs-selectAll-checkbox"
    );

    const selectAllCheckbox = document.getElementById(
      "cs-selectAll-checkbox"
    ) as HTMLInputElement;
    selectAllCheckbox?.addEventListener("change", function () {
      if (this.checked) {
        selectedFeedboxItems.selectAll($feeds);
      } else {
        selectedFeedboxItems.removeAll();
      }
    });

    // all $importFeedsBtns click event
    $importFeedsBtns?.forEach((actionBtn) => {
      actionBtn.addEventListener("click", async function () {
        const selectedFeeds = $feeds.filter((_, index) =>
          selectedFeedboxItems
            .getSelectedItems()
            .includes(`${itemIdPrefix}${index}`)
        );

        // check if selectedFeeds is empty
        if (selectedFeeds.length === 0) {
          addToast({ toastBody: "No reviews selected" }, "default", "error");
          return;
        }

        // check getFeedResp.source_id
        if (!getFeedResp.source_id) {
          addToast(
            { toastBody: "No source_id found, please search again!" },
            "default",
            "error"
          );
          return;
        }

        // import selected feeds
        try {
          ImportsModalCtx.setImportProcessRunning(true);
          $importFeedsBtns?.forEach((actionBtn) => disableButton(actionBtn));
          $feedsDisplaySection!.classList.add("pointer-events-none");
          await importService.importFeed("/coursera", {
            source_id: getFeedResp.source_id,
            selected_feeds: selectedFeeds,
          });
          addToast(
            { toastBody: "Selected reviews imported successfully. Create wall of love to showcase your good reviews from Pages section & embed to your website" },
            "default",
            "success"
          );
          children.GetCourseraReviewsForm.resetForm();
          resetSections();
          ImportsModalCtx.setIsImportProcessSuccess(true);
        } catch (error: any) {
          addToast({ toastBody: error.message }, "default", "error");
        } finally {
          ImportsModalCtx.setImportProcessRunning(false);
          ImportsModalCtx.setIsImportProcessSuccess(false);
          $feedsDisplaySection!.classList.remove("pointer-events-none");
          $importFeedsBtns?.forEach((actionBtn) => enableButton(actionBtn));
        }
      });
    });
  }

  function showSkeleton(enable: boolean) {
    if (enable) {
      $skeletonSection!.classList.remove("hidden");
      $informationSection!.classList.add("hidden");
      $feedsDisplaySection!.classList.add("hidden");
      $notFeedSection!.classList.add("hidden");
      return;
    } else {
      $skeletonSection!.classList.add("hidden");
      $informationSection!.classList.remove("hidden");
    }
  }

  function resetSections() {
    $feedList!.innerHTML = "";
    $feeds = [];
    getFeedResp = {};
    $feedsDisplaySection!.classList.add("hidden");
    $feedsDisplaySection!.classList.remove("pointer-events-none");
    $notFeedSection!.classList.add("hidden");
    $informationSection!.classList.remove("hidden");
    selectedFeedboxItems.removeAll();
    const selectAllCheckbox = document.getElementById(
      "cs-selectAll-checkbox"
    ) as HTMLInputElement;
    selectAllCheckbox.checked = false;
    enableImportBtn();
  }

  function displayFeeds(data: any) {
    showSkeleton(false);
    getFeedResp = data;
    if (
      data.data.all_reviews == undefined ||
      data.data.all_reviews.length === 0
    ) {
      $notFeedSection!.classList.remove("hidden");
      $informationSection!.classList.add("hidden");
      addToast({ toastBody: data.data.message }, "default", "success");
      return;
    }
    $feeds = data.data.all_reviews;
    populateFeeds();
  }

  function populateFeeds() {
    selectedFeedboxItems.initializeItems($feeds);
    $feedList!.innerHTML = "";
    $feeds.map((feed, index) => {
      const courseraReviewItem = CourseraReviewItem();
      $feedList!.insertAdjacentHTML(
        "beforeend",
        courseraReviewItem.render(feed, index)
      );

      const newFeedBoxCard = $feedList!.lastElementChild as HTMLElement | null;
      if (newFeedBoxCard) {
        // Initialize the checkbox item
        const newCheckboxItem =
          newFeedBoxCard.querySelector<HTMLInputElement>(".toggleCheckbox");
        if (newCheckboxItem) {
          initFeedCheckboxes(newCheckboxItem);
        }

        // Initialize the read more/less buttons for the current feed box card
        readMoreLessService.initializeReadMoreButtons(newFeedBoxCard);
      }
    });
    $feedsDisplaySection!.classList.remove("hidden");
    $informationSection!.classList.add("hidden");
    if (window.innerWidth > 768) {
      $feedsDisplaySection!.scrollIntoView({ behavior: "smooth" });
    }
  }

  function initFeedCheckboxes(checkboxItem: HTMLInputElement | null = null) {
    if (checkboxItem) {
      checkboxItem.addEventListener("change", function () {
        if (this.checked) {
          selectedFeedboxItems.addItem(this.id);
        } else {
          selectedFeedboxItems.removeItem(this.id);
        }
      });
      return;
    }
  }

  function enableImportBtn() {
    if (ImportsModalCtx.getImportProcessRunning()) return;
    $selectedFeedsCount!.innerText = selectedFeedboxItems
      .getSelectedItems()
      .length.toString();
    const enable = selectedFeedboxItems.getSelectedItems().length > 0;
    $importFeedsBtns?.forEach((actionBtn) => (actionBtn.disabled = !enable));
  }

  function render() {
    return /*html*/ `
        <div class="bg-white rounded-lg border border-gray-200 w-full dark:bg-neutral-800 dark:border-neutral-700">
            <div class="px-4 py-4">
                <div class="flex items-center justify-between gap-3">
                    <div class="flex items-center gap-3">
                        <h3 class="text-slate-900 text-base font-semibold font-['Inter'] dark:text-white">${title}</h3>
                    </div>
                </div>
                ${children.GetCourseraReviewsForm.render()}
            </div>
            <div id="cs-information-section" class="px-4 pb-5">
                <div class="p-5 min-h-[390px]  flex flex-col justify-center items-center text-center border rounded-lg border-gray-200 dark:border-neutral-700">
                    ${children.CourseraReviewsInfo.render()}
                </div>
            </div>
            <div id="cs-skeleton-section" class="hidden px-4 pb-5">
                ${children.ReviewSkeleton.render()}
            </div>
            <div id="cs-no-feed-section" class="hidden px-4 pb-5">
                <div class="p-5 min-h-[390px]  flex flex-col justify-center items-center text-center border rounded-lg border-gray-200 dark:border-neutral-700">
                    ${children.NoFeedSection.render()}
                </div>
            </div>
            <div id="cs-feed-list-section" class="hidden group overflow-hidden relative py-4 flex flex-col border-t border-gray-200 dark:border-neutral-700 md:sticky md:top-[57px]">
                <div class="px-4 flex flex-col sm:flex-row sm:items-center gap-4 justify-between">
                    <div>
                        <h3 class="text-slate-900 text-base font-semibold dark:text-white">Fetched Reviews</h3>
                        <p class="text-gray-600 text-sm font-[300] dark:text-neutral-500">Select reviews you want to import</p>
                    </div>
                    <div class="flex items-center gap-4">
                        <label for="cs-selectAll-checkbox"
                            class="inline-flex cursor-pointer py-1 px-2 border border-gray-200 rounded-md items-center disabled:pointer-events-auto disabled:opacity-75 h-[34px] dark:border-neutral-700">
                            <input type="checkbox"
                                class="cursor-pointer shrink-0 border-gray-200 rounded text-blue-600 focus:outline focus:shadow-none focus:ring-offset-0 focus:ring-0 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-800 dark:border-neutral-700 dark:checked:bg-blue-500 dark:checked:border-blue-500"
                                id="cs-selectAll-checkbox">
                            <span class="text-xs text-gray-500 ms-2 dark:text-neutral-400 cursor-pointer w-full whitespace-nowrap">Select All</span>
                        </label>
                        <div id="cs-layout-change-switch"></div>
                    </div>
                </div>
                <div class="pb-4 px-4 max-h-[calc(100vh-220px)] overflow-y-auto space-y-2 mt-4 [&::-webkit-scrollbar]:w-1.5
        [&::-webkit-scrollbar-track]:rounded-full
        [&::-webkit-scrollbar-track]:bg-white
        group-hover:[&::-webkit-scrollbar-track]:bg-gray-100
        [&::-webkit-scrollbar-thumb]:rounded-full
        [&::-webkit-scrollbar-thumb]:bg-white
        group-hover:[&::-webkit-scrollbar-thumb]:bg-gray-300
        dark:[&::-webkit-scrollbar-track]:bg-neutral-800
        group-hover:dark:[&::-webkit-scrollbar-track]:bg-neutral-700
        dark:[&::-webkit-scrollbar-thumb]:bg-neutral-800
        group-hover:dark:[&::-webkit-scrollbar-thumb]:bg-neutral-500">
                    <div class="group is-grid">
                        <div class="group-[.is-grid]:grid group-[.is-grid]:grid-cols-1 group-[.is-grid]:sm:grid-cols-2 group-[.is-grid]:xl:grid-cols-2 gap-2 xl:gap-3 space-y-2 group-[.is-grid]:space-y-0"id="cs-grid-view-feed-list">
                        </div>
                    </div>
                </div>
                <div class="rounded-b-lg overflow-hidden py-4 px-5 bg-white border-t border-gray-200 mb-[-16px] dark:bg-neutral-900 dark:border-neutral-700">
                    <button disabled 
                        type="button"
                        class="cs-import-btn w-full py-2 px-3 inline-flex justify-center items-center gap-x-1 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none">
                        <span class="btn-label flex gap-x-1 items-center">
                            Import <span id="cs-selected-feeds-count">0</span> Reviews
                        </span>
                    </button>
                </div>
            </div>

        </div>
        `;
  }

  return {
    init,
    render,
    children,
    resetSections
  };
}
